'use strict'

import * as THREE from 'three';
import Dat from 'dat.gui';
import init from 'three-dat.gui'; // Import initialization method

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import { SimplifyModifier } from 'three/examples/jsm/modifiers/SimplifyModifier.js';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

// import { RectAreaWEBPHelper } from 'three/examples/jsm/helpers/RectAreaLightHelper.js';
// import { RectAreaLightUniformsLib } from 'three/examples/jsm/lights/RectAreaLightUniformsLib.js';

import { HDRCubeTextureLoader } from 'three/examples/jsm/loaders/HDRCubeTextureLoader.js';
// import { RGBMLoader } from 'three/examples/jsm/loaders/RGBMLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';


const MANAGER = new THREE.LoadingManager();
const THREE_PATH = `https://unpkg.com/three@0.${__THREE__}.x`
const DRACO_LOADER = new DRACOLoader( MANAGER ).setDecoderPath( `${THREE_PATH}/examples/js/libs/draco/gltf/` );
const KTX2_LOADER = new KTX2Loader( MANAGER ).setTranscoderPath( `${THREE_PATH}/examples/js/libs/basis/` );

init(Dat);

export default class home3d_scene {
  constructor() {
    console.log('loading scene');

    this.run = false;

    this.mouseState = {
      held: false,
      clicked: false,
      lastClick: null,
    }
    this.raycastInterval = 60;
    this.lastRaycast = Date.now();

    var scene, camera, env, controls, renderer, meshes;

    var mouseX = 0;
    var mouseY = 0;

    var doGui = window.loggedIn;
    if(doGui) {
      var gui = this.gui = new Dat.GUI();
      gui.closed = true;
    }

    var guiExposure;

    this.modelsLoaded = false;

    var INTERSECTED = this.INTERSECTED = null;
    var PREV_INTERSECTED = this.PREV_INTERSECTED = null;
    var intersectables, raycaster, pointer;

    this.init = () => {
      var parent = this;
      meshes = this.meshes = [];

      console.log('init');

      renderer = this.renderer = new THREE.WebGLRenderer({
        autoClear: true,
        antialias: true,
        enableShadowMap: true,
        shadowMapType: THREE.PCFSoftShadowMap,
        powerPreference: "high-performance",
        // powerPreference: MOBILE ? "low-power" : "high-performance",
      });

      renderer.physicallyCorrectLights = true;
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.setClearColor( 0xDBD7D2, 1 );
      // renderer.setPixelRatio( 1 );
      renderer.setPixelRatio( window.devicePixelRatio );
      // renderer.setSize( el.clientWidth, el.clientHeight );
      renderer.setSize( window.innerWidth, window.innerHeight );
      $(renderer.domElement).addClass('three-canvas');
      $('.home3d--wrap').append( renderer.domElement );

      $(window).on('focus', function(){
        renderer.clear();
      });


      camera = this.camera = new THREE.PerspectiveCamera( 70, window.innerWidth / window.innerHeight, 0.01, 2000 );
      camera.position.x = 0;
      camera.position.y = 0;
      camera.position.z = window.cameraInitial;

      intersectables = this.intersectables = [];
      raycaster = new THREE.Raycaster();
      pointer = this.pointer = new THREE.Vector2(-999,-999);

      // function onDocumentMouseMove( event ) {
      document.addEventListener( 'mouseup', function(e){
        parent.mouseState.held = false;
      });

      document.addEventListener( 'mousedown', function(e){
        // parent.mouseState.held = false;
        parent.mouseState.lastClick = Date.now();
        parent.mouseState.clicked = false;
        parent.mouseState.held = true;
      });

      document.addEventListener( 'mousemove', function(e){
        if(window.mouseDownPos){
          var thisPos = {x: e.clientX, y:e.clientY};
          let xDiff = Math.abs(window.mouseDownPos.x - thisPos.x);
          let yDiff = Math.abs(window.mouseDownPos.y - thisPos.y);
          // console.log(xDiff, yDiff);
          if(Math.abs(xDiff + yDiff) > 10) {
            // console.log('cleared mousedownpos because drag');
            window.mouseDownPos = null;
            window.mousedownBlockID = null;
          }
        }

        // If we are panning, don't queue a raycast
        parent.qRaycast = !parent.mouseState.held;

        mouseX = ( e.clientX - window.innerWidth*.5 );
        mouseY = ( e.clientY - window.innerHeight*.5 );

        if(!MOBILE) {
          pointer.x = ( e.clientX / window.innerWidth ) * 2 - 1;
          pointer.y = - ( e.clientY / window.innerHeight ) * 2 + 1;
        }
        // console.log(mouseX, mouseY);
      });

      document.addEventListener('touchstart', function(e){
        // console.log(e);
        if(MOBILE) {
          pointer.x = ( e.touches[0].clientX / window.innerWidth ) * 2 - 1;
          pointer.y = - ( e.touches[0].clientY / window.innerHeight ) * 2 + 1;
        }
      });

      controls = new OrbitControls( camera, renderer.domElement );
      // controls.addEventListener( 'change', render ); // use if there is no animation loop

      // default should be 80
      // max distance should be 80

      controls.minDistance = window.cameraInitial - 15;
      controls.maxDistance = window.cameraInitial + 30;
      controls.target.set( 0, 0, -0.2 );
			controls.update();
      controls.zoomSpeed = 0.3;
      controls.enablePan = false;
			controls.enableDamping = true;

      this.controls = controls;

      scene = this.scene =  new THREE.Scene({
      });
      scene.fog = new THREE.FogExp2( 0xDBD7D2, 0.0025 );

      this.initHDR();
      this.initlights();

      // let geometry = new THREE.BoxGeometry( 0.2, 0.2, 0.2 );
      // let material = new THREE.MeshNormalMaterial();

      this.loadsLength = $('a.model').length;
      this.modelsLength = $('a.model').length;
      this.loadedPrc = 0;

      if(window.hdr) {
        this.loadsLength += 1;

        env = this.env = new RGBELoader()
        // .setPath( 'textures/equirectangular/' )
        .load( window.hdr, function ( texture ) {
          console.log(texture);
          texture.mapping = THREE.EquirectangularReflectionMapping;
          // scene.background = texture;
          scene.environment = texture;
          // render();
          // model
          parent.initmodels();

        }, function(xhr) {
          console.log(xhr);
          let envPrc = xhr.loaded / window.hdrSize;

          $('.loader').css('opacity',1);
          console.log(envPrc);
          parent.loadedPrc = 0;

          parent.loadedPrc += envPrc;

          var totalLoadPrc = parent.loadedPrc / parent.loadsLength;
          if(isNaN(totalLoadPrc)) totalLoadPrc = 0;
          $('.loader .prc').text(parseInt(totalLoadPrc*100)+'%');

        });
      } else {
        this.initmodels();
      }

    }

    this.start = () => {
      var parent = this;
      setTimeout(function(){
        parent.run = true;
        renderer.setAnimationLoop( parent.animation );
      }, 500);
    }

    this.initHDR = () => {
      var parent = this;

      const hdrParams = {
        exposure: window.exposure,
        toneMapping: window.tonemapping||'None',
      };

      renderer.toneMapping = hdrParams.toneMapping;
      renderer.toneMappingExposure = hdrParams.exposure;


      if(doGui) {
        parent.hdrFolder = gui.addFolder('HDR');

        const toneMappingOptions = {
          None: THREE.NoToneMapping,
          Linear: THREE.LinearToneMapping,
          Reinhard: THREE.ReinhardToneMapping,
          Cineon: THREE.CineonToneMapping,
          ACESFilmic: THREE.ACESFilmicToneMapping,
        };


        parent.hdrFolder.add( hdrParams, 'toneMapping', Object.keys( toneMappingOptions ))
        .onChange( function () {
          renderer.toneMapping = toneMappingOptions[ hdrParams.toneMapping ];
        });

        parent.hdrFolder.add( hdrParams, 'exposure', 0, 2 )
          .onChange( function () {
            renderer.toneMappingExposure = hdrParams.exposure;
          });


        // image upload
        var GuiConfig = function() {
          this['(Current) '] = window.hdrName;  // default image path

          this['Upload .hdr'] = function() {
            // you need to create an input element in HTML, explained later

            var input = document.getElementById('img-path');
            input.addEventListener('change', function() {
              var file = input.files[0];
              config['(Current) '] = file.name;
              // update all controllers

              var url = URL.createObjectURL( file );
              // console.log(input, file, url);

              env = parent.env = new RGBELoader()
              // .setPath( 'textures/equirectangular/' )
              .load( url, function ( texture ) {
                console.log(texture);
                texture.mapping = THREE.EquirectangularReflectionMapping;
                scene.environment = texture;
              }, function(xhr) {
                console.log(xhr);
                let envPrc = xhr.loaded / xhr.total;
                if(isNaN(envPrc)) envPrc = 0;
                $('.loader').css('opacity',1);
                $('.loader .prc').text(parseInt(envPrc*100)+'%');
                if(envPrc==1) {
                  $('.loader').css('opacity',0);
                }
              });

              for (var i in gui.__controllers) {
                gui.__controllers[i].updateDisplay();
              }
            });
            input.click();
          };
        };
        var config = new GuiConfig();
        parent.hdrFolder.add(config, 'Upload .hdr');
        parent.hdrFolder.add(config, '(Current) ', config['(Current) ']);
      }

    }

    this.initlights = () => {
      var parent = this;

      if(doGui) {
        this.lightsFolder = gui.addFolder('Lights');
      }

      this.lights = [];

      $('a.light').each(function(idx){
        let data = $(this).attr('data');
        data = JSON.parse(data);

        var bulbLight = new THREE.PointLight( data.color, data.intensity, data.distance, data.decay );
  			bulbLight.position.set( data.x, data.y, data.z );
  			bulbLight.castShadow = true;
        parent.lights.push(bulbLight);
  			scene.add( bulbLight );

        if(doGui) {
          parent.lightsFolder.addLight(`Light #${idx}`, bulbLight);
          scene.add( new THREE.PointLightHelper( bulbLight ) );
        }

      });

      // var ambientLight = this.ambientLight = new THREE.AmbientLight( 0x808080 ); // soft white light
      // scene.add( ambientLight );
      //
      // if(doGui) {
      //   this.lightsFolder.addLight('Ambient light', ambientLight);
      // }
      /*
      RectAreaLightUniformsLib.init();

      const rectLight1 = new THREE.RectAreaLight( 0x666600, 2, 100, 100 );
      rectLight1.position.set( -100, 25, 80 );
      rectLight1.rotateY(THREE.Math.degToRad(-50));
      rectLight1.rotateX(THREE.Math.degToRad(20));
      scene.add( rectLight1 );

      const rectLight2 = new THREE.RectAreaLight( 0x888888, 7, 150, 150 );
      rectLight2.position.set( 100, 5, 60 );
      rectLight2.rotateY(THREE.Math.degToRad(70));
      scene.add( rectLight2 );
      // scene.add( new RectAreaLightHelper( rectLight1 ) );
      // scene.add( new RectAreaLightHelper( rectLight2 ) );
      */


      /*
      const bulbGeometry = new THREE.SphereGeometry( 0.02, 16, 8 );
      var bulbLight = this.bulbLight = new THREE.PointLight( 0x887777, 10, 2000, 0.01 );
			bulbLight.position.set( 200, 30, 50 );
			bulbLight.castShadow = true;
			scene.add( bulbLight );


      var bulbLight2 = this.bulbLight2 = new THREE.PointLight( 0x776655, 15, 2000, 0.08 );
      bulbLight2.position.set( -80, 200, 50 );
			bulbLight2.castShadow = true;
			scene.add( bulbLight2 );

      var bulbLight3 = this.bulbLight3 = new THREE.PointLight( 0xff0000, 0, 2000, 0.08 );
      bulbLight3.position.set( 0, 0, 100 );
      bulbLight3.castShadow = true;
      scene.add( bulbLight3 );

      if(doGui) {
        this.lightsFolder.addLight('Light #1', bulbLight);
        this.lightsFolder.addLight('Light #2', bulbLight2);
        this.lightsFolder.addLight('Light #3', bulbLight3);
      }

      // scene.add( new THREE.PointLightHelper( bulbLight ) );
      // scene.add( new THREE.PointLightHelper( bulbLight2 ) );
      // scene.add( new THREE.PointlLightHelper( dirLight2 ) );
      */
    } // end initlights

    this.doFlashTitle = () => {
      if(!this.flashTitleDone) {
        this.flashTitleDone = true;
        $('.splashtext').remove();
        $('.loader').css('opacity',0);
        $('.page--title').css({'opacity' : 1});
        var len = $('.page--title').children().length;
        if(len>0) {
          setTimeout(function(){
            $('.loader').css('opacity',0);
            $('.page--title').children().each(function(idx){
              var t = $(this);
              setTimeout(function(){
                $(t).css('opacity', 0);
              }, 150 * (len-idx));
            });
          }, 4000);
        } else {
          setTimeout(function(){
            $('.page--title').animate({'opacity' : 0}, 300);
          }, 4500);
        }
      }
    }

    this.finalizeLoad = () => {
      var parent = this;
      $('.loader').removeClass('in');

      // if has the big text title, "in the making" or so
      if(window.doflashtitle) {
        parent.doFlashTitle();
      }


      if(doGui) {
        setTimeout(function(){
          console.log('tweaking GUI values');
          // tweak GUI values
          Object.keys(gui.__folders).forEach(function(topKey){
            let topFolder = gui.__folders[topKey];

            Object.keys(topFolder.__folders).forEach(function(key){
              let folder = topFolder.__folders[key];

              // first-level stuff like lights
              var ctrls = folder.__controllers;
              for(var i=0;i<ctrls.length;i++){
                let ctrl = ctrls[i];
                if(ctrl.property=='distance'){
                  ctrl.__max = 2000;
                  ctrl.updateDisplay();
                }
                if(ctrl.property=='intensity'){
                  ctrl.__max = 15;
                  ctrl.updateDisplay();
                }
              } // end lights

              // second-level, remove rotation folders
              Object.keys(folder.__folders).forEach(function(prop){
                // console.log(prop);
                let propFolder = folder.__folders[prop];
                // console.log(folder);
                if(prop=='rotation'){
                  folder.removeFolder(propFolder);
                }
                //console.log(folder.__folders[prop]);
              });

            }); // end inner folders
          });
        }, 1500);
      }
    }

    this.initmodels = () => {
      var parent = this;

      parent.loads = [];
      /*
      meshes.push(new THREE.Mesh( geometry, material ));

      for(var i=0; i<meshes.length; i++) {
        scene.add( meshes[i] );
      }
      */

      if(doGui) {
        parent.modelsFolder = gui.addFolder('3D Models');
      }

      parent.objectContainer = new THREE.Object3D();
      // parent.objectContainer.position.z = -5000;
      scene.add(parent.objectContainer);

      const loader = new GLTFLoader()
        .setCrossOrigin('anonymous')
        .setDRACOLoader( DRACO_LOADER )
        .setKTX2Loader( KTX2_LOADER.detectSupport( renderer ) )
        .setMeshoptDecoder( MeshoptDecoder );

      // Optional: Provide a DRACOLoader instance to decode compressed mesh data
      // const dracoLoader = new DRACOLoader();
      // dracoLoader.setDecoderPath( '/examples/js/libs/draco/' );
      // loader.setDRACOLoader( dracoLoader );

      $('a.model').each(function(idx){
        let data = $(this).attr('data');
        data = JSON.parse(data);

        $('.loader').addClass('in');

        // Load a glTF resource
        loader.load(
          // resource URL
          data.model,
          // 'models/gltf/duck/duck.gltf',
          // called when the resource is loaded
          function ( gltf ) {
            // console.log(gltf);

            var object = gltf.scene;

            var box = new THREE.Box3().setFromObject(object);
            var size = box.getSize(new THREE.Vector3()).length();
            var center = box.getCenter(new THREE.Vector3());

            object.position.x -= center.x;
            object.position.y -= center.y;
            object.position.z -= center.z;

            box.setFromObject(object);

            var pivot = new THREE.Object3D();

            let dir = Math.random() < .5 ? -1 : 1;
            pivot.spinSpeed = (0.001 + (0.001 * Math.random())) * dir;
            // pivot.spinSpeed = (0.002 + (0.001 * Math.random())) * dir;
            pivot.acceleration = 1;

            // RAYCAST

            /*
            object.traverse( function( node ) {
              if ( node.isMesh ) {
                node.blockID = data.id;
                node.pivot = pivot;
                if(data.fill !== '1') {
                  intersectables.push(node);
                }
                // node.castShadow = true;
                // node.receiveShadow = true;
                // object.receiveShadow = true;
              }
            });
            */

              // make a BoxBufferGeometry of the same size as Box3

            var doBoxAnyway = false;

            if(data.fill !== '1') {

              var hasBBOX = false;
              var bboxEl = null;

              object.traverse( function( node ) {
                if(node.name.toLowerCase() == 'bbox') {
                  // console.log('is bbox!');
                  hasBBOX = true;
                  bboxEl = node;
                }
              });

              if(!hasBBOX) {
                object.traverse( function( node ) {
                  if ( node.isMesh ) {
                    var mesh = node;
                    console.log(data.name+' has '+mesh.geometry.attributes.position.count+' vertices')
                    if(mesh.geometry.attributes.position.count < 30000) {
                      // console.log(mesh);
                      const modifier = new SimplifyModifier();
                      const simplified = mesh.clone();
                      simplified.material = new THREE.MeshBasicMaterial( { color: 0xff8888 } );
                      const count = Math.floor( simplified.geometry.attributes.position.count * 0.5 ); // number of vertices to remove
                      simplified.geometry = modifier.modify( simplified.geometry, count * .5 );
                      console.log('simplified "'+ data.name, '" from '+simplified.geometry.attributes.position.count+' vertices to '+count*.2);

                      var box = new THREE.Box3().setFromObject(simplified);
                      var size = box.getSize(new THREE.Vector3()).length();
                      var center = box.getCenter(new THREE.Vector3());

                      simplified.position.x -= center.x;
                      simplified.position.y -= center.y;
                      simplified.position.z -= center.z;

                      simplified.blockID = data.id;
                      simplified.pivot = pivot;

                      simplified.visible = false;

                      intersectables.push(simplified);
                      pivot.add( simplified );

                    } else {
                      if(doGui) {
                        alert('You\'re wanting to NOT have a box around the object: '+data.name+', but its vertex count is over 30000. In the .gltf, include a simplified mesh with "BBOX" in its name with a low vertex count, that would be used as the bounding box. For now, we\'ll use a box around it anyway.');
                      }
                      doBoxAnyway = true;
                    }
                  }
                });
              }
            }

            if(hasBBOX) {
              bboxEl.blockID = data.id;
              bboxEl.pivot = pivot;
              bboxEl.position.x -= center.x;
              bboxEl.position.y -= center.y;
              bboxEl.position.z -= center.z;
              bboxEl.visible = false;
              pivot.add(bboxEl);
              intersectables.push(bboxEl);
            }

            if(!hasBBOX && (data.fill=='1' || doBoxAnyway)) {

              const dimensions = new THREE.Vector3().subVectors( box.max, box.min );
              const boxGeo = new THREE.BoxBufferGeometry(dimensions.x, dimensions.y, dimensions.z);
              const matrix = new THREE.Matrix4().setPosition(dimensions.addVectors(box.min, box.max).multiplyScalar( 0.5 ));
              boxGeo.applyMatrix4(matrix);
              const boxMesh = new THREE.Mesh(boxGeo, new THREE.MeshBasicMaterial( { color: 0xffcc55 } ));
              boxMesh.visible = false;

              boxMesh.blockID = data.id;
              boxMesh.pivot = pivot;
              pivot.add(boxMesh);

              intersectables.push(boxMesh);
            }


            pivot.add( object );

            pivot.scale.set(data.scale, data.scale, data.scale);
            pivot.position.x += data.x;
            pivot.position.y += data.y;
            pivot.position.z += data.z;
            pivot.idealZ = data.z;

            if(doGui) {
              parent.modelsFolder.addObject3D(data.name, pivot);
            }

            pivot.visible = false;
            pivot.launchDone = false;
            pivot.position.z += window.startingPoint;

            parent.meshes.push(pivot);
            parent.objectContainer.add( pivot );

          },
          // called while loading is progressing
          function ( xhr ) {
            // console.log(xhr);
            // console.log( ( xhr.loaded / data.filesize * 100 ) + '% loaded' );
            // console.log( ( xhr.loaded / data.filesize * 100 ) + '% loaded' );
            let prc = xhr.loaded / data.filesize;
            parent.loads[idx] = prc;

            parent.loadedPrc = window.hdr ? 1 : 0;
            // console.log(parent.loadedPrc);

            for(var i=0; i<parent.modelsLength;i++) {
              parent.loadedPrc += parent.loads[i];
            }

            // console.log(parent.loadedPrc);

            var totalLoadPrc = parent.loadedPrc / parent.loadsLength;
            if(!isNaN(totalLoadPrc)) {
              $('.loader .prc').text(parseInt(totalLoadPrc*100)+'%');
              parent.modelsLoaded = totalLoadPrc == 1;
              if(parent.modelsLoaded){
                parent.finalizeLoad();
              }
            }
          },
          // called when loading has errors
          function ( error ) {

            console.log( 'An error happened' );

          }
        );
      }); // end a.model each
    }

    this.checkRaycast = () => {
      var parent = this;

      raycaster.setFromCamera( pointer, camera );
      const intersects = raycaster.intersectObjects( intersectables, false );

      if ( intersects.length > 0 ) {
        INTERSECTED = intersects[ 0 ].object;

        // if no previous OR the prev is not same ID, do actions
        if (!PREV_INTERSECTED || INTERSECTED.blockID != PREV_INTERSECTED.blockID){

          if(PREV_INTERSECTED){
            $(PREV_INTERSECTED.pivot).stop().animate({acceleration: 1}, {duration: 300});
          }

          if(INTERSECTED.pivot.launchDone) {
            if(!MOBILE) {
              $('.model.projectlink').removeClass('in');
              $(INTERSECTED.pivot).stop().animate({acceleration: 0}, 700);
              var link = $('[data-id="'+INTERSECTED.blockID+'"]');
              $(link).addClass('in');
              if($(link).attr('href')!=='#'){
                $('.three-canvas').css('cursor','pointer');
              }
            }
          }
        }

        PREV_INTERSECTED = INTERSECTED;
      } else {
        if ( INTERSECTED ) {
          if(INTERSECTED.pivot.launchDone) {
            if(!MOBILE) {
              $(INTERSECTED.pivot).stop().animate({acceleration: 1}, 1000);
              $('.three-canvas').css('cursor','default');
              $('.model.projectlink').removeClass('in');
            }
          }
        }
        INTERSECTED = null;
        PREV_INTERSECTED = null;
      }

      this.INTERSECTED = INTERSECTED;
      this.PREV_INTERSECTED = PREV_INTERSECTED;
    }

    this.animation = (time) => {
      if(this.run){

        if(this.modelsLoaded) {

          if(this.objectContainer.position.z < 0) {
            this.objectContainer.position.z += (0 - this.objectContainer.position.z) * .04;
            // camera.position.z += (100 - camera.position.z) * .04;
          }

          // the mousemove camera movement
          // camera.position.x += ( (mouseX * .125) - camera.position.x ) * .005;
          // camera.position.y += ( -(mouseY * .125) - camera.position.y ) * .007;
          // console.log(camera.position);

          controls.update();
          camera.updateMatrixWorld();

          // camera.lookAt(0, 0, 0);

          for(var i=0; i<this.meshes.length; i++) {
            var pivot = this.meshes[i];

            if(!pivot.launchDone && Math.abs(pivot.position.z - pivot.idealZ)>=3) {
              // pivot
              pivot.position.z += (pivot.idealZ - pivot.position.z) * (Math.abs(pivot.spinSpeed)*10);
            } else {
              pivot.launchDone = true;
            }

            pivot.visible = true;
            pivot.rotation.x = pivot.rotation.x + (pivot.spinSpeed * pivot.acceleration);
            pivot.rotation.y = pivot.rotation.y + (pivot.spinSpeed * pivot.acceleration);
          }

          if (Date.now() - this.lastRaycast > this.raycastInterval && this.qRaycast) {
            this.checkRaycast();
            // this.handleRaycast();
            this.lastRaycast = Date.now();
            this.qRaycast = false;
          }

        }

        renderer.render( scene, camera );

      }
    }

    this.init();

    window.addEventListener('resize', this.resize.bind(this), false);
  }

  resize () {
    // const {clientHeight, clientWidth} = window.innerWidth, window.innerHeight;

    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    // this.vignette.style({aspect: this.defaultCamera.aspect});
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  }

}
